import { Editor, Path } from 'slate';

export function isActiveNode(editor: Editor, path: Path): boolean {
  return editor.selection && Path.isAncestor(path, editor.selection.focus.path);
}
